import apiClient from '@/services/http/client'
import type { UserProfile } from '@/types'

export interface LoginPayload {
  email: string
  password: string
}

export interface SignupPayload {
  name: string
  email: string
  password: string
  studio_name: string
  timezone: string
}

export interface LoginResponse {
  token: string
}

export const loginRequest = async (payload: LoginPayload) => {
  const response = await apiClient.post<{ data: { token: string } }>('/api/v1/auth/login', payload)
  return { token: response.data.data.token }
}

export const logoutRequest = async () => {
  await apiClient.post('/api/v1/auth/logout')
}

export const fetchMe = async () => {
  const response = await apiClient.get<{ data: UserProfile }>('/api/v1/auth/me')
  return response.data.data
}

export const signupRequest = async (payload: SignupPayload) => {
  const response = await apiClient.post<{ data: { token: string } }>('/api/v1/auth/register', payload)
  return { token: response.data.data.token }
}
